import { apiClient, fetchAllPages } from '@/shared/api';
import type {
  AttributeGroupCreate,
  AttributeGroupDeleteParams,
  AttributeGroupListParams,
  AttributeGroupListResponse,
  AttributeGroupResponse,
  AttributeGroupUpdate,
} from './attributeGroupTypes';

/**
 * GET /attribute-group - list attribute groups
 */
export const fetchAttributeGroups = async (params?: AttributeGroupListParams) => {
  const { data } = await apiClient.get<AttributeGroupListResponse>('/attribute-group', { params });
  return data;
};

/** Наибольшее окно выдачи групп атрибутов, которое принимает сервер */
const ATTRIBUTE_GROUPS_MAX_LIMIT = 1000;

/** Весь набор групп атрибутов — окнами выдачи до последней группы ({@link fetchAllPages}) */
export const fetchAllAttributeGroups = async (): Promise<AttributeGroupListResponse> => {
  const { items, total } = await fetchAllPages(async (offset, limit) => {
    const page = await fetchAttributeGroups({ limit, offset });
    return { items: page.attributeGroups, total: page.total };
  }, ATTRIBUTE_GROUPS_MAX_LIMIT);

  return { total, attributeGroups: items };
};

/**
 * GET /attribute-group/{code} - get attribute group by code
 */
export const fetchAttributeGroupByCode = async (code: string) => {
  const { data } = await apiClient.get<AttributeGroupResponse>(`/attribute-group/${code}`);
  return data;
};

/**
 * POST /attribute-group - create attribute group
 */
export const createAttributeGroup = async (attributeGroup: AttributeGroupCreate) => {
  const { data } = await apiClient.post<AttributeGroupResponse>('/attribute-group', attributeGroup);
  return data;
};

/**
 * PUT /attribute-group/{code} - update attribute group
 */
export const updateAttributeGroup = async ({ code, body }: { code: string; body: AttributeGroupUpdate }) => {
  const { data } = await apiClient.put<AttributeGroupResponse>(`/attribute-group/${code}`, body);
  return data;
};

/**
 * DELETE /attribute-group/{code} - delete attribute group
 */
export const deleteAttributeGroup = async (code: string, params?: AttributeGroupDeleteParams) => {
  await apiClient.delete(`/attribute-group/${code}`, { params });
};
